import api from './api.service';

class StudyService {
    private url: string = 'student/course';

    getStudy(data: string) {
        return api.get(`${this.url}/me?${data}`)
    }

    getFavorites(data: string) {
        return api.get(`${this.url}/favorites/me?${data}`)
    }

    postFavorite(data: { course_id: string }) {
        return api.post(`${this.url}/favorites`, data)
    }
    deleteFavorite(course_id:string) {
        return api.delete(`${this.url}/favorites/${course_id}`)
    }

    getTeachers() {
        return api.get(`${this.url}/teacher/list`)
    }

}

export const studyService = new StudyService()